import React, { useState, useRef } from "react";
import { Upload, Sparkles, Loader2 } from "lucide-react";
import { aiQuick } from "../api";

export default function Video() {
  const [src, setSrc] = useState("");
  const [name, setName] = useState("");
  const [desc, setDesc] = useState("");
  const [aiOut, setAiOut] = useState("");
  const [busy, setBusy] = useState(false);
  const fileRef = useRef(null);

  const onFile = (e) => {
    const f = e.target.files?.[0];
    if (!f) return;
    setSrc(URL.createObjectURL(f));
    setName(f.name);
  };

  const aiAnalyze = async () => {
    setBusy(true);
    setAiOut("");
    try {
      const r = await aiQuick(
        `Video filename: ${name || "(unknown)"}. User description: ${desc || "(none)"}\n\nGenerate likely scene summaries, suggested chapters and topic tags for this video.`,
        "You are an AI video metadata generator."
      );
      setAiOut(r.text);
    } catch { setAiOut("AI unavailable."); }
    setBusy(false);
  };

  return (
    <div className="h-full flex" data-testid="app-video">
      <div className="flex-1 flex flex-col p-4 gap-3">
        <div className="flex items-center gap-2">
          <button data-testid="video-upload" onClick={() => fileRef.current?.click()} className="btn-ghost text-xs flex items-center gap-1">
            <Upload size={12} /> Open Video
          </button>
          <input type="file" accept="video/*" hidden ref={fileRef} onChange={onFile} />
          {name && <span className="text-[10px] text-white/40 truncate max-w-[260px]">{name}</span>}
        </div>
        <div className="flex-1 bg-black rounded-lg overflow-hidden flex items-center justify-center">
          {src ? (
            <video src={src} controls className="w-full h-full object-contain" data-testid="video-player" />
          ) : (
            <div className="text-white/40 text-sm">Choose a video file</div>
          )}
        </div>
      </div>
      <div className="w-96 border-l border-white/10 bg-black/30 flex flex-col">
        <div className="p-3 border-b border-white/10 flex items-center gap-1.5 text-xs uppercase tracking-widest text-white/40">
          <Sparkles size={12} color="#ff7a2e" /> AI Video Tools
        </div>
        <div className="p-3 flex-1 overflow-y-auto space-y-3">
          <div className="text-[10px] uppercase tracking-widest text-white/40">Describe the video</div>
          <textarea
            data-testid="video-desc"
            rows={4}
            value={desc}
            onChange={(e) => setDesc(e.target.value)}
            placeholder="e.g. 5 min product demo of our app"
            className="w-full bg-white/5 border border-white/10 rounded p-2 text-xs"
          />
          <button data-testid="video-ai-analyze" disabled={busy} onClick={aiAnalyze} className="btn-accent text-xs w-full flex items-center justify-center gap-1">
            {busy ? <Loader2 size={12} className="animate-spin" /> : <Sparkles size={12} />} Generate Chapters & Tags
          </button>
          {aiOut && <div className="text-xs whitespace-pre-wrap bg-white/5 border border-white/10 p-2 rounded">{aiOut}</div>}
        </div>
      </div>
    </div>
  );
}
